module.exports = __webpack_public_path__ + "static/media/creditCardsTransit.b54ab1a4.svg";